import { ValidatedDynamicListFormComponentProps } from '@finbeat/react-toolkit';
import { BOValidatedDatePicker } from 'base-components/BOValidatedDatePicker/BOValidatedDatePicker';
import { timeWithSecondsFormat } from 'constans/dateFormat';
import { useTranslation } from 'react-i18next';

type TimeProps = ValidatedDynamicListFormComponentProps & {
    periodIdx: number;
    disabled: boolean;
};

const ModalFundsTransferSettingTime = ({
    idx,
    fieldId,
    checkDouble,
    periodIdx,
    disabled,
}: TimeProps) => {
    const { t } = useTranslation();
    return (
        <td>
            <BOValidatedDatePicker
                disabled={disabled}
                inputProps={{
                    label: t('BackOfficeTime'),
                }}
                name={`periods.${periodIdx}.schedule.${idx}.time`}
                dateFormat={timeWithSecondsFormat}
                timeOnly
                rules={{
                    validate: () => checkDouble(fieldId) ?? undefined,
                }}
            />
        </td>
    );
};

export default ModalFundsTransferSettingTime;
